<script lang="ts" setup>
import type { LogicalFilter } from '#layers/data-model';
import type { FilterSchemaCollection } from './utils/filter-schema';
import { isEmptyFilter } from '#layers/data-model';
import { ButtonRemove } from '#layers/ui';

defineProps<{
	collection: FilterSchemaCollection;
}>();

defineEmits<{
	remove: [];
}>();

const filter = defineModel<LogicalFilter>({ required: true });
</script>

<template>
	<DPopover
		:content="{ side: 'bottom', align: 'start' }"
		:ui="{ content: 'bg-default p-2.5' }"
	>
		<FilterHandleGroup>
			<DButton
				color="neutral"
				variant="ghost"
				size="sm"
				class="flex gap-3 ps-3"
			>
				<DChip v-if="!isEmptyFilter(filter)" size="sm" :ui="{ base: 'ring-0' }" />
				<span>{{ $t('filters.advanced_filter') }}</span>
			</DButton>
			<FilterRemove @remove="$emit('remove')" />
		</FilterHandleGroup>
		<template #content>
			<div class="flex flex-col gap-2">
				<FilterLogicalGroup
					v-model="filter"
					:collection
					:hide-group-actions="false"
				/>
				<DSeparator />
				<ButtonRemove
					class="text-muted"
					with-leading-icon
					:label="$t('filters.remove_filter')"
					@click="$emit('remove')"
				/>
			</div>
		</template>
	</DPopover>
</template>
